var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.1207 24.9251c2.0731.1398 3.8742.0749 3.8742.0749s1.829.066 3.923-.0777c-.3636 1.6271-1.9759 3.0777-3.9242 3.0777-1.9362 0-3.5158-1.4489-3.873-3.0749z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9949 24s10.0051.3613 10.0051-2.4451c0-1.0451-1.0819-1.9856-1.9942-2.916-.6987-.721-.8886-2.205-.9734-3.407-.0746-4.0133-1.1565-6.78279-3.9749-7.78612-.4036-1.35884-1.4957-2.44578-3.0626-2.44578-1.5567 0-2.659 1.08694-3.0524 2.44578-2.8184 1.00333-3.90027 3.77282-3.97489 7.78612-.08479 1.202-.27471 2.686-.97337 3.407-.92251.9304-1.99424 1.8709-1.99424 2.916 0 2.8055 9.9949 2.4451 9.9949 2.4451z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.d123a0073ed33e509b5ca96382d6e8b9.svg";
export { ForwardRef as ReactComponent };